import React from "react";
import TaskStatusWeidget from "./TaskStatusWeidget";
import CAMDrawer from "../../../components/LeftSideBar/CAMDrawer";
import InvestigatorContainer from "../../../components/contsiners/InvestigatorContainer";
import CAMHeader from "../../../components/Header/CAMHeader";

export default function TaskStatusWidgetDashboard() {
  return (
    <>
      <CAMHeader />
      <CAMDrawer />
      <InvestigatorContainer>
        <TaskStatusWeidget />
      </InvestigatorContainer>
    </>
  );
}
